/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';

export const LinkButtonCtaStyled = styled(Link)`
  ${({ theme }) => {
    const smallDown = theme.smallDown();
    return css`
      ${smallDown && 'width: 100%;'}
      ${smallDown && 'max-width: unset;'}
    `;
  }}
`;
